import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Row,
  Col,
  Input,
  Label,
} from "reactstrap";
import "../index.scss";
import LoaderUI from "../../../../components/common/loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SendRequestModal from "../../Halycon/sendRequestModal.js/index.js";
import { toasterConfig } from "../../../../utils/constants";
import { faFilePdf, faDownload } from "@fortawesome/free-solid-svg-icons";
import PushIcon from '../../../../assets/img/icons/push-icon.svg';
import How_to_Create_an_IRS_Account from '../../../../sample-files/How_to_Create_an_IRS_Account.pdf'
toast.configure();

const CsvModal = ({
  closeModal,
  showModel,
  _toggle,
  addOperator,
  updateOperator,
  operatorDetail,
  disabled,
  locations,
  lodder,
  heading,
}) => {
  const history = useHistory();
  const [height, setHeight] = useState("0");
  let [modalStatus, setModalStatus] = useState(false);

  const close = () => {
    closeModal();
    setHeight("0");
  };

  const saveVersion = () => {
    setModalStatus(true);
    setTimeout(() => {
      setModalStatus(false);

      history.push("/income_analyzer");
      toast.success("Document Uploaded sucessfully", toasterConfig);
    }, 5000);
  };

  const handleDownloadPDF = () => {
    let a = document.createElement('a');
    a.href = How_to_Create_an_IRS_Account;
    a.download = 'How_to_Create_an_IRS_Account.pdf';
    a.click();
  }



  return (
    <>
      <SendRequestModal _modalStatus={modalStatus} heading={heading} />
      <Modal isOpen={showModel} backdrop="static">
        <ModalHeader>
          {heading}
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            onClick={close}
          ></button>
        </ModalHeader>
        <ModalBody style={{ minHeight: height }}>

          {/* <div className="date-time-dropdown-blc d-flex flex-column align-items-center position-absolute">

          </div> */}{" "}
          {/*  <======= default div present for body */}
          {heading == "Download Options" ? (
            <div>
              <span></span>
              <Row>
                <Col>
                  <div className="view-box-wrap-main no-background">
                    <div className="view-box-wrap">
                      <div className="view-box-content">
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>Download Transcripts</span>
                          </Label>
                        </FormGroup>

                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>Download Cash Flow Analysis</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>Download Income Documents</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>Download All Documentation</span>
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="view-box-wrap-main">
                    <div className="view-box-wrap">
                      <h3>Download Info For:</h3>
                      <div className="view-box-content">
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo1" />{" "}
                            <span>Jonathan Trained</span>
                          </Label>
                        </FormGroup>

                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo1" />{" "}
                            <span>Christine Trained</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo1" />{" "}
                            <span>All Borrowers</span>
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                    <Button color="primary"><FontAwesomeIcon icon={faDownload} /> Download </Button>
                  </div>
                </Col>
              </Row>
            </div>
          ) : heading == "Previous Calculations" ? (
            <div>
              <Row>
                <Col>
                  <div className="view-box-wrap-main no-background">
                    <div className="view-box-wrap">
                      <div className="view-box-content">
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>May 28, 2022</span>
                          </Label>
                        </FormGroup>

                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>Jan 22, 2022</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>August 28, 2022</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>March 4, 2022</span>
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="view-box-wrap-main">
                    <div className="view-box-wrap">
                      <h3>Download Info For:</h3>
                      <div className="view-box-content">
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo1" />{" "}
                            <span>Jonathan Trained</span>
                          </Label>
                        </FormGroup>

                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo1" />{" "}
                            <span>Christine Trained</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo1" />{" "}
                            <span>All Borrowers</span>
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                    <Button color="primary"><FontAwesomeIcon icon={faDownload} /> Download </Button>
                  </div>
                </Col>
              </Row>
            </div>
          ) : heading == "ID.me PDF Instructions" ? (
            <div className="download-popup">
              <Row className="text-center align-items-center">
                <Col>
                  <p className="f-icons">
                    <FontAwesomeIcon icon={faFilePdf} />
                  </p>
                </Col>
                <Col>
                  <h6>{heading} Guide</h6>
                  <Button color="primary" onClick={handleDownloadPDF}>
                    <FontAwesomeIcon icon={faDownload} />
                    Download
                  </Button>
                </Col>
              </Row>
            </div>
          ) : heading == "Push Data to LOS" ? (
            <div>
              <Row>
                <Col>
                  <div className="view-box-wrap-main">
                    <div className="view-box-wrap">
                      <h3>Download Info For:</h3>
                      <div className="view-box-content">
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>Jonathan Trained</span>
                          </Label>
                        </FormGroup>

                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>Christine Trained</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input type="radio" name="viewingInfo" />{" "}
                            <span>All Borrowers</span>
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="text-center">
                    <div className="push-btn-wrapper">
                      <Button block color="primary" className="d-flex justify-content-center align-items-center"
                        onClick={() => {
                          saveVersion();
                          close();
                        }} ><img src={PushIcon} alt="Push Data" /> Click Here To Push Data to LOS</Button>
                    </div>
                    <Button
                      style={{ marginTop: '1rem' }}
                      color="primary"
                      onClick={close}
                    >
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            "null"
          )}{" "}
          {/*   <======== Conditional rendering */}
        </ModalBody>
      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default CsvModal;
